import { use } from 'react';

import CareConnectSettingsProviderContext from 'features/care-connect-settings/contexts/care-connect-settings-provider-context';
import CareConnectCallPlanDetails from './care-connect-call-plan-details';
import CareConnectPersonalNumberRangeDetails from './care-connect-personal-number-range-details';
import styles from './care-connect-settings-details.module.scss';

const CareConnectSettingsDetails = (): React.JSX.Element => {
  const { selectedOrganisationUnit } = use(CareConnectSettingsProviderContext);

  return (
    <div className={`${styles.container} ${selectedOrganisationUnit ? styles.isOpen : ''}`}>
      {selectedOrganisationUnit &&
        (selectedOrganisationUnit.isRoot ? <CareConnectPersonalNumberRangeDetails /> : <CareConnectCallPlanDetails />)}
    </div>
  );
};

export default CareConnectSettingsDetails;
